import { useState, useEffect, useCallback } from "react";
import API from "utils/api";

export default function useWellnessScores() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchScores = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await API.get("/wellness-coach/sentiment");
      setData(response.data);
    } catch (err) {
      console.error("Failed to fetch wellness scores:", err);
      setError(err.message || "Failed to fetch wellness scores");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchScores();
  }, [fetchScores]);

  return { data, loading, error, refetch: fetchScores };
}
